const state = {
  cuposRs: { cupos: [], busqueda: null, limpiando: false },
  sinDispo: { is: false },
  destino: null
}
const getters = {
  getCuposRs: state => {
    return state.cuposRs
  },
  getSinDispo: state => {
    return state.sinDispo
  },
  getCantPaxRq: state => {
    const totales = state.cuposRs.busqueda.habitaciones.reduce((acumulador, actual) => {
      return {
        adl: acumulador.adl + actual.adl,
        bebe: acumulador.bebe + actual.bebe,
        chd: acumulador.chd + actual.chd,
        jr: acumulador.jr + actual.jr
      }
    })
    const cantidad = Object.values(totales)
      .filter(t => Number.isInteger(t))
      .reduce((acumulador, actual) => acumulador + actual)
    return cantidad
  },
  getDestino: state => {
    return state.destino
  }
}
const actions = {
  guardarCuposRs({ commit, state, dispatch }, item) {
    try {
      commit("setSinDispo", { is: false })
      commit("setCuposRs", item)
      if (item.cupos.length === 0 && !item.limpiando) {
        commit("setSinDispo", {
          is: true,
          mensaje: "No se encontraron cupos para la fecha seleccionada."
        })
      }
    } catch (e) {
      console.log(e)
      commit("setSinDispo", {
        is: true,
        mensaje: "Ha ocurrido un error, inténtelo de nuevo, en caso de continuar contacte al administrador."
      })
    }
  },
  guardarSinDispo({ commit, state, dispatch }, item) {
    commit("setSinDispo", item)
  },
  guardarDestino({ commit }, item) {
    commit("setDestino", item)
  }
}
const mutations = {
  setCuposRs(state, item) {
    state.cuposRs = item
  },
  setSinDispo(state, item) {
    state.sinDispo = item
  },
  setDestino(state, item) {
    state.destino = item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
